export const HEADER_HEIGHT = 52; // TODO: заменить на DESKTOP_HEADER_HEIGHT
export const DESKTOP_HEADER_HEIGHT = 56;
export const MOBILE_HEADER_HEIGHT = 52;
